module.exports = __webpack_public_path__ + "img/placeholder.24dc9edd.jpg";